<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-02 09:16:28
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-08-02 09:45:06
 * @Description: 面包屑导航
-->
<template>
  <div class="list">
    <div
      class="item"
      v-for="(item, index) in pageTitle"
      :key="index"
      @click="() => toPage(item.url)"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageTitle: Array,
    default: function () {
      return []
    }
  },
  methods: {
    toPage (url) {
      this.$router.push({ path: url })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  align-items: center;
  height: 49px;
  padding: 0 16px;
  background: rgb(247, 248, 250);
  .item {
    color: #666666;
    cursor: pointer;
    &::after {
      margin: 0 10px;
      color: #666666;
      content: '/';
    }
    &:hover {
      color: #1d65a8;
    }
    &:last-child {
      color: #333;
      cursor: default;
      &::after {
        content: '';
      }
    }
  }
}
</style>
